<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'acquisti.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="save" *ngIf="!acquisto.data_pagamento_e" class="close" (click)="save()" aria-label="Close">
      <span aria-hidden="true"><i class="fas fa-save"></i></span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label for="fornitore" class="control-label col-form-label">{{'acquisti.cliente' | translate}}</label>
          <ng-multiselect-dropdown [settings]="clientiDropdownSettings" [placeholder]="'acquisti.cliente' | translate"
            id="fornitore" [data]="Fornitori" [(ngModel)]="FornitoriSelezionati" (ngModelChange)="FornitoreChanged()">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label class="control-label col-form-label">{{'acquisti.dprevista' | translate}}:</label>
          <input type="date" [(ngModel)]="acquisto.data_prevista" class="form-control">
        </div>
      </div>
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label class="control-label col-form-label">{{'acquisti.demissione' | translate}}:</label>
          <input type="date" [(ngModel)]="acquisto.data_emissione" class="form-control">
        </div>
      </div>

      <div class="col-sm-12 col-md-12"
        *ngIf="!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine']">
        <div class="form-group">
          <label for="data_pagamento_p" class="control-label col-form-label">{{'acquisti.data_pagamento_p' |
            translate}}:</label>
          <input type="date" [(ngModel)]="acquisto.data_pagamento_p" class="form-control" id="data_pagamento_p">
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label for="anno" class="control-label col-form-label">{{'acquisti.anno' | translate}}:</label>
          <input type="text" [(ngModel)]="acquisto.anno" class="form-control" id="anno">
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label for="progressivo" class="control-label col-form-label">{{'acquisti.progressivo' | translate}}:</label>
          <input type="text" [(ngModel)]="acquisto.progressivo" class="form-control" id="progressivo">
        </div>
      </div>
      <div class="col-sm-12 col-md-3"
        *ngIf="!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine']">
        <div class="form-group">
          <label for="annullato" class="control-label col-form-label">{{'Annullato' | translate}}:</label>
          <input type="checkbox" [(ngModel)]="acquisto.annullato" class="form-control" id="annullato">
        </div>
      </div>
      <div class="col-sm-12 col-md-3"
        *ngIf="!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine']">
        <div class="form-group">
          <label for="proforma" class="control-label col-form-label">{{'Proforma' | translate}}:</label>
          <input type="text" [(ngModel)]="acquisto.proforma" class="form-control" id="proforma">
        </div>
      </div>
      <div class="col-sm-12 col-md-12"
        *ngIf="!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine']">
        <div class="form-group">
          <label for="note" class="control-label col-form-label">{{'Note' | translate}}:</label>
          <textarea [(ngModel)]="acquisto.note" class="form-control" id="note"></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <!--    [isModifyDisabled]="acquisto.data_pagamento_e != undefined && acquisto.data_pagamento_e != null"-->
    <app-voci-di-costo *ngIf="acquisto && acquisto.voci" [HasIva]="false" [HasProdottiDropdown]="false"
      [title]="'Beni da acquistare'" [externalAddFunction]="true" [externalEditFunction]="true"
      [externalDeleteFunction]="true" [HasTotaleRiga]="true" [HasPrezzo]="true" [HasTotale]="true"
      [HasImponibile]="true" [CampoPrezzo]="'costo'" (AddClicked)="EditVoce()" (UpdateClicked)="EditVoce($event)"
      (DeleteClicked)="DeleteVoce($event)" (DuplicaClicked)="Duplica($event)" [HasDuplicaButton]="true"
      [CampiAggiuntivi]="CampiAggiuntiviVoci()"
      [HasEditButton]="!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine']"
      [BottoniAggiuntivi]="[{onClick: OnArrivatiClick, icon: 'fa-truck', tooltip:'Arrivati', color: 'orange'}]"
      [HasUm]="false" [HasAddSconto]="environment.ProdottiAddOn['voceCostoSconto']" [(myProp)]="acquisto" (resetpage)="refresh()

"></app-voci-di-costo>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <!--*ngIf="!acquisto.data_pagamento_e"-->
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-save"></i> {{'acquisti.salva' | translate}} </span>
  </button>
  <button (click)="InviaAdhoc()"
    *ngIf="acquisto?.id && !acquisto.data_pagamento_e && (!environment['MaterialiAddOn'] || !environment['MaterialiAddOn']['Ordine'])"
    [disabled]="invioAdhoc" class=" btn btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-upload"></i>&nbsp;{{'acquisti.inviaadhoc' |
      translate}} </span>
  </button>
  <!-- <button (click)="InviaAdhoc()" *ngIf="acquisto?.id && acquisto.data_pagamento_e" [disabled]="invioAdhoc"  class=" btn btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-upload"></i>&nbsp;Reinvia ad Adhoc</span>
  </button>-->
</div>